import Incidencias from './incidencias.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

// Gating: checkPermission no soporta usernames (solo roles, y solo como fallback
// cuando no hay menú del backend). El acceso (ADMIN/DIRECTOR + JJCS) lo garantizan
// el backend (403 al resto) y la entrada del grupo PLANIFICACIONES en el menú.
var routes = [
    {
        path: '/incidencias/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('incidencias', ['ADMIN', 'DIRECTOR'], Incidencias),
        keepAlive: true
    }
];
export default routes;
